var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellPubli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "var(--main-forte)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0277 24.8611H20.9722M17.1666 28.75H22.8333C24.4901 28.75 25.8333 27.4069 25.8333 25.75V14.25C25.8333 12.5931 24.4901 11.25 22.8333 11.25H17.1666C15.5098 11.25 14.1666 12.5931 14.1666 14.25V25.75C14.1666 27.4069 15.5098 28.75 17.1666 28.75Z",
    stroke: "url(#paint0_linear_4_300)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_300",
    x1: 14.1666,
    y1: 28.75,
    x2: 27.7417,
    y2: 27.1173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1975FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellPubli);
export default __webpack_public_path__ + "static/media/cell_publi.f23e032ea90bf9e210a06a5df990f443.svg";
export { ForwardRef as ReactComponent };